import { render, staticRenderFns } from "./Mark.vue?vue&type=template&id=26d0207c&scoped=true"
import script from "./Mark.vue?vue&type=script&lang=js"
export * from "./Mark.vue?vue&type=script&lang=js"
import style0 from "./Mark.vue?vue&type=style&index=0&id=26d0207c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26d0207c",
  null
  
)

export default component.exports